import type { INearestAirport } from '@/types/OrigDest'
import { COOKIE_OPTIONS } from '@/utils/constants/cookies'
import { useLocaleStore } from '@/stores/Locale.store'
import { getAirbalticApiUrl } from '@/server/utils/airbalticApiUrl'
import { APIResponse } from '@/server/utils/apiHandler'

const getNearestAirportData = (data: ILocationData): INearestAirport => {
  return {
    code: data.nearestAirport,
    cityCode: data.regionCode,
    isAllAirports: false,
    countryCode: data.country
  }
}

const ONE_HOUR = 3600

export const useFetchGeolocate = async () => {
  const localeStore = useLocaleStore()

  const nearestAirportCookie = useCookie<INearestAirport>('nearestAirportData', { ...COOKIE_OPTIONS, maxAge: ONE_HOUR })
  const countryCookie = useCookie('country', COOKIE_OPTIONS)

  const gdprCookies = useCookie<string>('gdpr_settings', COOKIE_OPTIONS)

  if (gdprCookies.value?.includes('fnc') && (!nearestAirportCookie.value || !countryCookie.value)) {
    try {
      const response = await fetchGeolocate()

      if (response.success && 'data' in response && response.data) {
        nearestAirportCookie.value = getNearestAirportData(response.data)

        localeStore.setSelectedCountry(response.data.country)
      }

      if (!response.success) {
        console.error('Failed to fetch response geolocation: ', response.error)
      }
    } catch (error) {
      console.error('Error fetching geolocation: ', error)
    }
  }
}

const fetchGeolocate = async () => {
  const locationDataResponse = new APIResponse<ILocationData | null>()

  await useFetch(getAirbalticApiUrl('/location/data'), {
    method: 'GET',
    headers: {
      accept: 'application/json'
    },
    onResponse: ({ response }) => {
      locationDataResponse.handleResponse(response)
    }
  }).catch((response) => locationDataResponse.handleError(response))

  return locationDataResponse.getData()
}

interface ILocationData {
  latitude: string
  longitude: string
  country: string
  regionCode: string
  continent: string
  city: string
  timezone: string
  nearestAirport: string
  language: string
}
